"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONTabConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var paragraph_style_1 = require("../../paragraph/paragraph-style");
var json_sub_document_enums_1 = require("../enums/json-sub-document-enums");
var JSONTabConverter = (function () {
    function JSONTabConverter() {
    }
    JSONTabConverter.convertFromJSONToTabProperties = function (obj) {
        var tabs = new paragraph_style_1.TabProperties();
        for (var _i = 0, obj_1 = obj; _i < obj_1.length; _i++) {
            var jsonTab = obj_1[_i];
            tabs.tabsInfo.push(JSONTabConverter.convertFromJSON(jsonTab));
        }
        return tabs;
    };
    JSONTabConverter.convertFromJSON = function (obj) {
        return new paragraph_style_1.TabInfo(obj[json_sub_document_enums_1.JSONTabInfoProperty.Position], obj[json_sub_document_enums_1.JSONTabInfoProperty.Alignment], obj[json_sub_document_enums_1.JSONTabInfoProperty.LeaderType], !!obj[json_sub_document_enums_1.JSONTabInfoProperty.IsDeleted], !!obj[json_sub_document_enums_1.JSONTabInfoProperty.IsDefault]);
    };
    JSONTabConverter.convertToJSON = function (source) {
        var result = {};
        result[json_sub_document_enums_1.JSONTabInfoProperty.Position] = source.position;
        result[json_sub_document_enums_1.JSONTabInfoProperty.Alignment] = source.alignment;
        result[json_sub_document_enums_1.JSONTabInfoProperty.LeaderType] = source.leader;
        result[json_sub_document_enums_1.JSONTabInfoProperty.IsDeleted] = common_1.boolToInt(source.deleted);
        result[json_sub_document_enums_1.JSONTabInfoProperty.IsDefault] = common_1.boolToInt(source.isDefault);
        return result;
    };
    JSONTabConverter.convertFromTabPropertiesToJSON = function (source) {
        var result = [];
        for (var _i = 0, _a = source.tabsInfo; _i < _a.length; _i++) {
            var tab = _a[_i];
            result.push(JSONTabConverter.convertToJSON(tab));
        }
        return result;
    };
    return JSONTabConverter;
}());
exports.JSONTabConverter = JSONTabConverter;
